import { Component, DoCheck, inject } from '@angular/core';
import { NgxDropzoneChangeEvent, NgxDropzoneModule } from 'ngx-dropzone';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { UploadService } from '../../service/upload.service';
import { ButtonDirective, ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'ik-upload',
    templateUrl: './upload.component.html',
    styleUrls: ['./upload.component.scss'],
    standalone: true,
    //providers: [UploadService],
    imports: [CommonModule, NgxDropzoneModule, ButtonDirective, ButtonModule]
})
export class UploadComponent implements DoCheck {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  uploadService = inject(UploadService);

  files: File[] = [];

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);
  constructor() {}

  /**
   * A PrimeNG DynamicDialog a `closable`/`closeOnEscape`/`dismissableMask`
   * mezőket élőben, minden change detection körben újraolvassa a `config`
   * objektumból (nem csak a `dialogService.open(...)` hívás pillanatában) -
   * ezért ez a `ngDoCheck` elég ahhoz, hogy feltöltés közben ne lehessen
   * bezárni a dialógust (X gomb, ESC, kattintás a háttérre), utána viszont
   * megint lehessen.
   */
  ngDoCheck(): void {
    const closable = !this.uploadService.uploading;
    this.config.closable = closable;
    this.config.closeOnEscape = closable;
    this.config.dismissableMask = closable;
  }

  onSelect(event: NgxDropzoneChangeEvent) {
    this.files.push(...(event.addedFiles as File[]));
  }

  onRemove(event: File) {
    this.files.splice(this.files.indexOf(event), 1);
  }
}